import FormControlLabel from './form-control-label';

export default FormControlLabel;
